import Cookies from 'js-cookie'
import { MessageBox } from 'element-ui'
import store from '@/store'

const TokenKey = 'mj_token'
const IsTestKey = 'lzy_yyds'

// localStorage 不受 Edge 跟踪防护拦截，作为主存储
// Cookie 作为兼容降级（某些场景如跨页跳转可能需要）

export function getToken() {
  // 优先从 localStorage 读取，回退到 Cookie
  const localToken = localStorage.getItem(TokenKey)
  if (localToken) return localToken
  const cookieToken = Cookies.get(TokenKey)
  if (cookieToken) {
    // Cookie 有值但 localStorage 没有，补写到 localStorage
    localStorage.setItem(TokenKey, cookieToken)
  }
  return cookieToken
}
export function getIsTest() {
  const localVal = localStorage.getItem(IsTestKey)
  if (localVal !== null) return localVal % 2
  const cookieVal = Cookies.get(IsTestKey)
  if (cookieVal !== undefined) {
    localStorage.setItem(IsTestKey, cookieVal)
  }
  return cookieVal % 2 // 单数是超管 双数是用户
}

export function getUserId() {
  return store.getters.user_id
}

export function setToken(token, is_test) {
  // 单数是超管 双数是用户
  let id = parseInt((Math.random() * 1000000000).toString())
  if (is_test && id % 2 !== 1) {
    id = id - 1
  } else if (!is_test && id % 2 === 1) {
    id = id - 1
  }
  // 双写：localStorage + Cookie
  localStorage.setItem(IsTestKey, id)
  localStorage.setItem(TokenKey, token)
  Cookies.set(IsTestKey, id)
  Cookies.set(TokenKey, token)
  return token
}
export function removeToken() {
  localStorage.removeItem(IsTestKey)
  localStorage.removeItem(TokenKey)
  Cookies.remove(IsTestKey)
  return Cookies.remove(TokenKey)
}

export function LogBack(msg) {
  MessageBox.alert(msg, {
    confirmButtonText: '确定',
    type: 'warning',
    callback: action => {
      store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
    }
  })
}
